"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportSettingsForm = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const form_1 = require("../../../composite/form/form");
const list_source_hook_1 = require("../../../utils/list-source-hook");
const form_text_field_1 = require("../../../composite/form/fields/form-text-field");
const form_number_field_1 = require("../../../composite/form/fields/form-number-field");
const form_checkbox_1 = require("../../../composite/form/fields/form-checkbox");
const form_date_field_1 = require("../../../composite/form/fields/form-date-field");
const form_date_time_field_1 = require("../../../composite/form/fields/form-date-time-field");
const form_time_field_1 = require("../../../composite/form/fields/form-time-field");
const form_select_1 = require("../../../composite/form/fields/form-select");
const form_autocomplete_1 = require("../../../composite/form/fields/form-autocomplete");
const autocomplete_source_hook_1 = require("../../../components/autocomplete/autocomplete-source-hook");
const reporting_types_1 = require("../reporting-types");
exports.ReportSettingsForm = react_1.forwardRef(
// eslint-disable-next-line no-empty-pattern
function ReportSettingsForm({ definition }, ref) {
    var _a;
    const inputFields = (_a = definition === null || definition === void 0 ? void 0 : definition.inputFields) !== null && _a !== void 0 ? _a : [];
    return (react_1.default.createElement(form_1.Form, { ref: ref, initialValues: {}, onSubmit: lodash_1.noop, editing: true }, inputFields.map((field) => (react_1.default.createElement(InputField, { key: field.name, field: field })))));
});
function InputField({ field }) {
    switch (field.type) {
        case reporting_types_1.ReportInputFieldType.TEXT:
            return react_1.default.createElement(form_text_field_1.FormTextField, { name: field.name, label: field.label });
        case reporting_types_1.ReportInputFieldType.NUMBER:
            return react_1.default.createElement(form_number_field_1.FormNumberField, { name: field.name, label: field.label });
        case reporting_types_1.ReportInputFieldType.BOOLEAN:
            return react_1.default.createElement(form_checkbox_1.FormCheckbox, { name: field.name, label: field.label });
        case reporting_types_1.ReportInputFieldType.DATE:
            return react_1.default.createElement(form_date_field_1.FormDateField, { name: field.name, label: field.label });
        case reporting_types_1.ReportInputFieldType.DATETIME:
            return react_1.default.createElement(form_date_time_field_1.FormDateTimeField, { name: field.name, label: field.label });
        case reporting_types_1.ReportInputFieldType.TIME:
            return react_1.default.createElement(form_time_field_1.FormTimeField, { name: field.name, label: field.label });
        case reporting_types_1.ReportInputFieldType.SELECT:
            return react_1.default.createElement(SelectInputField, { field: field });
        case reporting_types_1.ReportInputFieldType.AUTOCOMPLETE:
            return react_1.default.createElement(AutocompleteInputField, { field: field });
        default:
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
function SelectInputField({ field }) {
    var _a;
    const source = list_source_hook_1.useStaticListSource((_a = field.selectItems) !== null && _a !== void 0 ? _a : []);
    return (react_1.default.createElement(form_select_1.FormSelect, { name: field.name, label: field.label, source: source, valueIsId: true }));
}
function AutocompleteInputField({ field }) {
    const source = autocomplete_source_hook_1.useAutocompleteSource({
        url: field.autocompleteUrl,
        apiUrl: field.autocompleteApiUrl,
        params: field.autocompleteParams,
    });
    return (react_1.default.createElement(form_autocomplete_1.FormAutocomplete, { name: field.name, label: field.label, multiple: true, source: source, labelMapper: (a) => a.label, tooltipMapper: (a) => a.label }));
}
//# sourceMappingURL=report-settings-form.js.map